import { CPHeader } from "../../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import "./header.scss";
import { NavItems, navItems } from "../../../constants";
import { useCallback, useEffect, useMemo } from "react";
import { isTokenValid } from "../../../utils/token";
import { Response } from "../../../constants/api";
import { useDispatch } from "react-redux";
import { setUserInfo, userState } from "../../../store/slices/user";
import { useAppSelector } from "../../../app/hooks";
import {
  setTotals,
  setTransactions,
  transactionState,
} from "../../../store/slices/transaction";
import { getTransactionsByUserId } from "../../../api/transaction";
import { getUserById } from "../../../api/user";
import { TransactionTypeEnum } from "../../../constants/transaction";

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useAppSelector(userState);
  const { transactions } = useAppSelector(transactionState);

  const getUser = useCallback(async () => {
    const userId = user?.userId || localStorage.getItem("userId");
    const userResponse: Response = await getUserById(userId);

    if (userResponse?.success) {
      dispatch(setUserInfo({ ...userResponse?.result }));

      const transactionResponse: Response = await getTransactionsByUserId(
        userId || userResponse?.result?._id,
      );

      if (transactionResponse?.success) {
        dispatch(setTransactions(transactionResponse?.result));
      }
    }
  }, [dispatch, user]);

  useEffect(() => {
    const token: string | null = localStorage.getItem("token");
    const isValidToken = isTokenValid(token);

    if (isValidToken) getUser();
    else navigate("/login");
  }, [navigate, getUser]);

  useMemo(() => {
    const totals: any = {
      income: transactions
        .filter((item) => item.type === TransactionTypeEnum.INCOME)
        .reduce((sum, item) => sum + item.amount, 0),
      expense: transactions
        .filter((item) => item.type === TransactionTypeEnum.EXPENSE)
        .reduce((sum, item) => sum + item.amount, 0),
      transfer: transactions
        .filter((item) => item.type === TransactionTypeEnum.TRANSFER)
        .reduce((sum, item) => sum + item.amount, 0),
    };

    dispatch(setTotals({ ...totals }));
  }, [transactions, dispatch]);

  return (
    <header className="cp-header">
      <img src={CPHeader} alt="" />
      <nav className="cp-header__nav">
        <ul>
          {navItems?.map((item: NavItems, index: number) => {
            const isActive = location?.pathname === item.href;

            return (
              <li
                className={isActive ? "cp-header__nav--active" : ""}
                key={`${item.label}-${index}`}
              >
                <a href={item.href}>{item.label}</a>
              </li>
            );
          })}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
